// material-ui
import { Theme } from '@mui/material/styles';

// project imports
import { withAlpha } from 'utils/colorUtils';

// ==============================|| OVERRIDES - LIST ITEM BUTTON ||============================== //

export default function ListItemButton(theme: Theme) {
  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          color: theme.vars.palette.text.primary,
          paddingTop: '10px',
          paddingBottom: '10px',

          '&.Mui-selected': {
            color: theme.vars.palette.secondary.dark,
            backgroundColor: theme.vars.palette.secondary.light,
            '&:hover': {
              backgroundColor: theme.vars.palette.secondary.light
            },
            '& .MuiListItemIcon-root': {
              color: theme.vars.palette.secondary.dark
            },

            // secondary is the brand navy, which disappears on the dark sidebar, so use the light blue instead
            ...theme.applyStyles('dark', {
              color: theme.vars.palette.primary.light,
              '& .MuiListItemIcon-root': {
                color: theme.vars.palette.primary.light
              },
              backgroundColor: withAlpha(theme.vars.palette.primary.main, 0.25),
              '&:hover': {
                backgroundColor: withAlpha(theme.vars.palette.primary.main, 0.3)
              }
            })
          },

          '&:hover': {
            backgroundColor: theme.vars.palette.secondary.light,
            color: theme.vars.palette.secondary.dark,
            '& .MuiListItemIcon-root': {
              color: theme.vars.palette.secondary.dark
            },

            ...theme.applyStyles('dark', {
              color: theme.vars.palette.primary.light,
              backgroundColor: withAlpha(theme.vars.palette.primary.main, 0.15),
              '& .MuiListItemIcon-root': {
                color: theme.vars.palette.primary.light
              }
            })
          }
        }
      }
    }
  };
}
